import React, { useState, useRef, useEffect } from 'react'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

import AddToCart from '../components/add-to-cart'
import TryItFree from '../components/try-it-free'

import downloadWhite from '../images/svgs/download-icon-white.svg'
import chevronrightwhite from '../images/svgs/chevron-right-white.svg'

export default function FoldNav({ product, showNav = true }) {
    const { product_name, rawHTMLContent } = product

    const scrollbarRef = useRef(null)
    const [scrollPostionX, setScrollPositionX] = useState(0)

    useEffect(() => {
        scrollbarRef.current?.scroll({
            top: 0,
            left: scrollPostionX,
            behavior: 'smooth',
        })
    }, [scrollPostionX])

    return (
        <Container fluid className='bg-dark py-2 position-sticky' style={{ top: 54, zIndex: 980 }}>
            <Container>
                <Row className='justify-content-between'>
                    <Col xs='auto'>
                        <p className='mb-0 text-uppercase text-white ff-primary fw-bold' style={{ fontSize: 24 }}>
                            {product_name}
                        </p>
                    </Col>

                    {
                        (!rawHTMLContent && showNav) &&
                        <Col className='d-flex overflow-hidden'>
                            {
                                scrollPostionX !== 0 &&
                                <Button variant='' onClick={() => setScrollPositionX(scrollPostionX - 100)}>
                                    <img src={chevronrightwhite} alt='' style={{ transform: 'rotate(180deg)' }} />
                                </Button>
                            }

                            <Stack ref={scrollbarRef}
                                direction='horizontal'
                                gap={5}
                                className='overflow-auto hide-scrollbar scrollsnapx'
                            >
                                <p className='mb-0 text-uppercase text-primary fw-bold ff-primary flex-grow-0 scrollsnap-align-start'>Overview</p>
                                <p className='mb-0 text-uppercase text-white fw-bold ff-primary flex-grow-0 scrollsnap-align-start'>Testimonial</p>
                                <p className='mb-0 text-uppercase text-white fw-bold ff-primary flex-grow-0 scrollsnap-align-start'>Features</p>
                                <p className='mb-0 text-uppercase text-white fw-bold ff-primary flex-grow-0 scrollsnap-align-start'>Walkthrough</p>
                                <p className='mb-0 text-uppercase text-white fw-bold ff-primary flex-grow-0 scrollsnap-align-start'>Preview</p>
                                <p className='mb-0 text-uppercase text-white fw-bold ff-primary flex-grow-0 scrollsnap-align-start'>Video</p>
                                <p className='mb-0 text-uppercase text-white fw-bold ff-primary flex-grow-0 scrollsnap-align-start'>Demo</p>
                                <p className='mb-0 text-uppercase text-white fw-bold ff-primary flex-grow-0 scrollsnap-align-start'>Expansions</p>
                                <p className='mb-0 text-uppercase text-white fw-bold ff-primary flex-grow-0 scrollsnap-align-start text-nowrap'>System Requirements</p>
                                <p className='mb-0 text-uppercase text-white fw-bold ff-primary flex-grow-0 scrollsnap-align-start'>Trial</p>
                            </Stack>

                            <Button variant='' onClick={() => setScrollPositionX(scrollPostionX + 100)}>
                                <img src={chevronrightwhite} alt='' />
                            </Button>
                        </Col>
                    }

                    <Col xs='auto'>
                        <Stack direction='horizontal' gap={3}>
                            <TryItFree product={product}
                                className='flex-center gap-1 border border-white text-white'
                                style={{
                                    fontSize: 14,
                                    height: 40,
                                    width: 180,
                                }}
                            >
                                <img src={downloadWhite} alt='' />
                                TRY IT FREE
                            </TryItFree>
                            <AddToCart
                                product={product}
                                className='flex-center gap-1 border border-primary bg-primary'
                                style={{
                                    fontSize: 14,
                                    height: 40,
                                    width: 180,
                                }}
                            />
                        </Stack>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}